import React, { FC } from 'react';
import MuiDivider, { DividerProps as MuiDividerProps } from '@material-ui/core/Divider';
import { Uds } from '../../types';

export type DividerProps = Uds<MuiDividerProps & {}>;

export const Divider: FC<React.PropsWithChildren<DividerProps>> = ({ dataTest, ...props }) => (
  <MuiDivider data-test={dataTest} {...props} />
);
